export function NavbarPromoSlot() {
  // IAS overlay: no promo/upgrade surfaces in the main navbar.
  return null;
}
